import {
  handlingItemPlaceholder,
  goodsItemPlaceholder,
  getInputText
} from "@/views/personal/deliver/components/handlingWrapper/config";

export const handlingMixins = {
  data() {
    return {
      ruleForm: {},
      rules: {},
      handlingItemPlaceholder,
      goodsItemPlaceholder,
      currentIndex: ""
    };
  },
  methods: {
    getInputText,
    initData() {
      this.setRuleForm();
      this.setRules();
    },
    setRuleForm() {
      this.ruleForm = {
        0: {
          startPoint: "",
          startPointCity: "",
          startPointDistrict: "",
          startPointLocation: "",
          startPointProvince: "",

          startAddress: "",

          startContactName: "",
          startContactPhone: "",

          endAddress: "",
          endContactName: "",
          endContactPhone: "",
          endPoint: "",
          endPointCity: "",
          endPointDistrict: "",
          endPointLocation: "",
          endPointProvince: "",

          expectDeliveryTime: "",
          expectArrivalTime: "",

          goods: [
            {
              goodsCategoryid: "", //改成货号
              goodsName: "",
              goodsNumber: "",
              goodsWeight: ""
            }
          ]
        }
      };
    },
    setRules() {
      let obj = {},
        handlingKeysArr = Object.keys(this.handlingItemPlaceholder),
        goodsKeysArr = Object.keys(this.goodsItemPlaceholder);
      Object.values(this.ruleForm).map((item, index) => {
        Object.keys(item).map(childItem => {
          if (childItem !== "goods") {
            let tempHandlingObj = this.handlingItemPlaceholder[childItem];
            if (tempHandlingObj) {
              let { type, text, mustFill } = tempHandlingObj;
              if (mustFill) {
                if (handlingKeysArr.includes(childItem)) {
                  // 装卸
                  obj[`${index}.${childItem}`] = [
                    {
                      required: true,
                      message: this.getInputText(childItem),
                      trigger:
                        childItem === "startPoint" || childItem === "endPoint"
                          ? ["change"]
                          : ["blur", "change"]
                    }
                  ];
                }
              }
            }
          } else {
            item.goods.map((goodsItem, goodsIndex) => {
              Object.keys(goodsItem).map(goodsChildItem => {
                let tempGoodsObj = this.goodsItemPlaceholder[goodsChildItem];
                if (tempGoodsObj) {
                  let { type, text, mustFill } = tempGoodsObj;
                  if (mustFill) {
                    if (goodsKeysArr.includes(goodsChildItem)) {
                      // 装卸
                      obj[`${index}.goods.${goodsIndex}.${goodsChildItem}`] = [
                        {
                          required: true,
                          message: this.getInputText(goodsChildItem),
                          trigger: ["blur", "change"]
                        }
                      ];
                    }
                  }
                }
              });
            });
          }
        });
      });
      this.rules = obj;
    },
    addGoodsSuccess(obj) {
      this.ruleForm[this.currentIndex].goods.push(obj);
      this.setRules();
    },
    async addToCommonUse({ currentIndex }) {
      // 验证当前选项卡中的路线选项是否完整
      let reg = new RegExp(`^${currentIndex}.(start|end)`);
      let rulesArr = Object.keys(this.rules).filter(item => reg.test(item));
      try {
        await this.formValidate(rulesArr);
        this.$refs.handlingCard[currentIndex].doAddConfirm();
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async formValidate(rulesArr = Object.keys(this.rules)) {
      let data = await Promise.all(
        rulesArr.map(item => {
          return new Promise((resolve, reject) => {
            this.$refs.ruleForm.validateField(item, e => {
              e = e && { text: e, key: item };
              resolve(e);
            });
          });
        })
      );
      let validatedArr = data.filter(item => item);
      if (!validatedArr.length) {
        return Promise.resolve(1);
      } else {
        this.activeNames = Number(validatedArr[0].key.split(".")[0]) + 1;
        return Promise.reject(new Error(""));
      }
    },
    async addGoodsValidate({ currentIndex }) {
      this.currentIndex = currentIndex;
      try {
        await this.goodsInforValidate();
        this.$refs.handlingCard[currentIndex].showGoodsDialog(currentIndex);
      } catch (e) {
        return false;
      }
    },
    async goodsInforValidate() {
      let goodsValidateArr = Object.keys(this.rules).filter(item =>
        item.startsWith(`${this.currentIndex}.goods`)
      );
      let data = await Promise.all(
        goodsValidateArr.map(item => {
          return new Promise((resolve, reject) => {
            this.$refs.ruleForm.validateField(item, e => {
              resolve(e);
            });
          });
        })
      );
      if (!data.filter(item => item).length) {
        return Promise.resolve(1);
      } else {
        return Promise.reject(new Error(""));
      }
    },
    async goodsDel(obj) {
      await this.$myConfirm("确定要删除此货物吗", this);
      let { bigIndex, index } = obj;
      this.ruleForm[bigIndex].goods.splice(index, 1);
      this.setRules();
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/personal/deliver/components/handlingWrapper/mixins/handlingMixins.js